import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import "./style.css";

import QRPrintModal from "../../components/QRPrintModal/QRPrintModal";

import { selectCurrentUserRecord } from "../../store/common/userRecord/slice";
import { useAppStore } from "../../store";

const SidePanel = ({ menuItems, collapsed, onCollapse, shopName, activeKey }) => {
  const [showQRModal, setShowQRModal] = useState(false);
    const userRecord = useAppStore(selectCurrentUserRecord);

  // Split menu items: all except logout, and logout
  const mainItems = menuItems.filter((item) => item.key !== "logout");
  const logoutItem = menuItems.find((item) => item.key === "logout");

  // Generate chat URL for QR code
  const businessNameSlug =
    shopName?.toLowerCase().replace(/\s+/g, "-") || "";
  const chatUrl = `${window.location.origin}/${businessNameSlug}`;

  return (
    <>
      <aside
        className={`side-panel${collapsed ? " collapsed" : ""}`}
        style={{ width: collapsed ? 60 : 260 }}
        aria-label="Side navigation"
      >
        <div className="side-panel-header">
          <button
            className="collapse-btn"
            onClick={onCollapse}
            aria-label="Toggle menu"
          >
            <i
              className={`pi pi-${collapsed ? "angle-right" : "angle-left"}`}
            ></i>
          </button>
        </div>
        <nav className="side-panel-menu" aria-label="Main menu">
          {mainItems.map((item) => (
            <button
              key={item.key}
              className={`side-panel-menu-item${
                activeKey === item.key ? " active" : ""
              }`}
              onClick={item.command}
              aria-label={item.label}
              tabIndex={0}
            >
              <i className={item.icon}></i>
              {!collapsed && (
                <span className="side-panel-menu-label">
                  {item.label}
                  {item.new && <span className="menu-new-badge"> - New</span>}
                </span>
              )}
            </button>
          ))}
        </nav>
        <div className="side-panel-actions">
          <button
            className="side-panel-menu-item share-qr"
            onClick={() => setShowQRModal(true)}
            aria-label="Share QR Code"
            tabIndex={0}
          >
            <i className="pi pi-qrcode"></i>
            {!collapsed && (
              <span className="side-panel-menu-label">Share QR</span>
            )}
          </button>
          {logoutItem && (
            <button
              key={logoutItem.key}
              className="side-panel-menu-item logout"
              onClick={logoutItem.command}
              aria-label={logoutItem.label}
              tabIndex={0}
            >
              <i className={logoutItem.icon}></i>
              {!collapsed && (
                <span className="side-panel-menu-label">
                  {logoutItem.label}
                </span>
              )}
            </button>
          )}
        </div>
      </aside>

      <Dialog
        header={
          <div className="flex align-items-center gap-2">
            <i className="pi pi-qrcode text-2xl text-primary-500"></i>
            <span>Share QR Code</span>
          </div>
        }
        visible={showQRModal}
        onHide={() => setShowQRModal(false)}
        style={{ width: "50dvw" }}
        modal
        dismissableMask
        closeOnEscape
      >
        <QRPrintModal
          shopName={shopName}
          chatUrl={chatUrl}
          userRecord={userRecord}
        />
      </Dialog>
    </>
  );
};

export default SidePanel;
